import ApiGet from "../../../../../api-module/api-configuration/get-api/getApi";
import { API_ENDPOINTS } from "../../apiGroup/apiProvider";
import { CmsGlobals, FindBySlugResponse } from "./cmsGlobals.types";

type CacheEntry<T> = { data: T; expiresAt: number };

const TTL_MS = 60 * 60 * 1000;
const cache = new Map<string, CacheEntry<CmsGlobals>>();
const inflight = new Map<string, Promise<CmsGlobals>>();

export async function fetchCmsGlobals(signal?: AbortSignal) {
  const key = "cms:globals";

  const cached = cache.get(key);
  if (cached && Date.now() < cached.expiresAt) return cached.data;

  const running = inflight.get(key);
  if (running) return running;

  const req = Promise.all([
    ApiGet<FindBySlugResponse>(API_ENDPOINTS.FIND_BY_SLUG, { params: { slug: "header" }, signal }),
    ApiGet<FindBySlugResponse>(API_ENDPOINTS.FIND_BY_SLUG, { params: { slug: "footer" }, signal }),
  ])
    .then(([headerRes, footerRes]) => {
      const headerLayout = headerRes.data?.data?.data?.header ?? null;
      const footerLayout = footerRes.data?.data?.data?.footer ?? null;

      const globals: CmsGlobals = {
        // you don't have updatedAt in the response you showed; use createdAt or remove this field
        updatedAt: [headerRes.data?.data?.createdAt, footerRes.data?.data?.createdAt]
          .filter(Boolean)
          .sort() //NOSONAR
          .pop(),
        header: headerLayout,
        footer: footerLayout,
      };

      cache.set(key, { data: globals, expiresAt: Date.now() + TTL_MS });
      return globals;
    })
    .finally(() => inflight.delete(key));

  inflight.set(key, req);
  return req;
}

export function invalidateCmsGlobals() {
  cache.delete("cms:globals");
}
